import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import { fullNameSchema, fullNameUI } from '../../definitions';
import content from '../../locales/en/content.json';

const TITLE_TEXT = content['certifier--name-title'];
const DESC_TEXT = content['certifier--name-description'];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    contactName: fullNameUI(),
  },
  schema: {
    type: 'object',
    required: ['contactName'],
    properties: {
      contactName: fullNameSchema,
    },
  },
};
